// extracted by mini-css-extract-plugin
export var active = "_1u-7";
export var container = "_1u-0";
export var evenWidth = "_1u-4";
export var large = "_1u-5";
export var outlet = "_1u-8";
export var slide = "_1u-2";
export var small = "_1u-6";
export var tab = "_1u-3";
export var tabs = "_1u-1";